function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.682%",
  y1: "49.681%",
  x2: "100.53%",
  y2: "100.529%",
  id: "bullet_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A5E6CF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.252%",
  y1: "49.275%",
  x2: "-.536%",
  y2: "1.075%",
  id: "bullet_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A5E6CF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "-.266%",
  x2: "50%",
  y2: "101.453%",
  id: "bullet_svg__h"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A5E6CF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  id: "bullet_svg__a",
  d: "M62.932.135L0 63.068h62.932z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bullet_svg__d",
  d: "M.932.068V63L63.865.068z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bullet_svg__g",
  d: "M0 .068L62.932 63V.068z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -.135)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bullet_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bullet_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bullet_svg__b)",
  mask: "url(#bullet_svg__c)",
  d: "M62.932.135L0 63.068h62.932z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#45CE9B",
  d: "M62.932 0v62.933h62.933z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(62 62.865)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bullet_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bullet_svg__d"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bullet_svg__e)",
  mask: "url(#bullet_svg__f)",
  d: "M.932.068V63L63.865.068z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 62.865)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bullet_svg__i",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bullet_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bullet_svg__h)",
  mask: "url(#bullet_svg__i)",
  d: "M0 .068L62.932 63V.068z"
})));

function SvgBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgBullet as ReactComponent };